import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { VInput } from '@/package';

import type { TaskCreateFormType } from './type';

export const TaskFrameInterval = ({ readOnly }: { readOnly: boolean }) => {
  const { t } = useTranslation();
  const {
    register,
    getValues,
    formState: { touchedFields },
  } = useFormContext<TaskCreateFormType>();

  const validate = (value?: string | number) => {
    const currentValue = value ?? getValues('workFrameInterval');
    return Boolean(currentValue && Number(currentValue) > 0);
  };

  return (
    <VInput
      required
      fluid
      label={t('task.createTaskFrameInterval.sacrilegiousness')}
      {...register('workFrameInterval', { validate })}
      valid={!touchedFields.workFrameInterval || validate()}
      readOnly={readOnly}
    />
  );
};
